module.exports = __webpack_public_path__ + "img/Chart-Area-Color.779facb5.png";